<template>

    <trax-account-user-edit-data :with-username="withUsername" :my-profile="myProfile" :self-edit="selfEdit" :form-extend="form" :disable-required-fields="1" :source="source" :target="target">

        <trax-ui-input type="text" icon="phone" :placeholder="lang.polaris.common.phone"
            v-model="form.meta.phone" v-bind:error="errors.phone">
        </trax-ui-input>

        <trax-ui-datetime icon="child_care" :placeholder="lang.polaris.common.birth_date"
            v-model="form.meta.birth_date" v-bind:error="errors.birth_date" 
            type="date" view-mode="years">
        </trax-ui-datetime>

        <trax-ui-datetime icon="local_hospital" :placeholder="lang.polaris.common.medical_exam_expiry_date"
            v-model="form.meta.medical_exam_expiry_date" v-bind:error="errors.medical_exam_expiry_date" 
            type="date" view-mode="years">
        </trax-ui-datetime>

    </trax-account-user-edit-data>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-account-user-edit'},
            withUsername: null,
            myProfile: null,
            selfEdit: null,
            source: {default: '1'},
            target: {default: 'final'}
        },
        
        data: function() {
            return {
                lang: lang,
                form: {
                    meta: {},
                },
                errors: {},
                bus: this.$bus
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-data', function(data) {
                that.selectData(data);
            });

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });
        },

        methods: {

            selectData(data) {
                this.data = data;
                for (var index in this.form) {
                    if (index == 'meta' && Array.isArray(data.meta)) {
                        this.form.meta = {};
                    } else {
                        this.form[index] = data[index];
                    }
                }
            }
        }
    }
</script>
